// extracted by mini-css-extract-plugin
export default {"user-link":"_3041p","userLink":"_3041p","link-banned":"_37naM","linkBanned":"_37naM"};